import { Skeleton } from '@mui/material';

export const TableSkeleton = ({ rows, columns }) => (
  <div className="loading-table">
    <Skeleton
      variant="rectangular"
      width="100%"
      height={29}
      style={{
        backgroundColor: '#f5f8ff',
        borderTopLeftRadius: 5,
        borderTopRightRadius: 5,
      }}
    />
    {Array.from({ length: rows ?? 10 }).map((_, rowIndex) => (
      <div className="table-row" key={rowIndex}>
        {Array.from({ length: columns < 5 ? columns : 6 }).map(
          (_, colIndex) => {
            let flexStyle = { flexGrow: 1, height: '34px' };
            if (colIndex === 0) {
              flexStyle = { flexGrow: 0.33 };
            } else if (colIndex === 14) {
              flexStyle = { flexGrow: 0.66 };
            }

            return (
              <div className="table-cell" key={colIndex} style={flexStyle}>
                <div className="cell-skeleton"></div>
              </div>
            );
          }
        )}
      </div>
    ))}
  </div>
);
